import axios from '@/plugins/http/axios.js';
import config from "@/views/users/pages/massive/config/loader_api.js";

export const usersMassiveService = {
  // Descargar plantilla de cargue
  downloadUploadTemplate: (idEmpresa) => {
    const url = `${config.baseUrl}${config.port}${config.context}/user/import/affiliates/template`;
    return axios.get(
      url,
      {
        headers: {
          'idEmpresa': idEmpresa
        },
        responseType: 'blob'
      }
    );
  },

  // Cargar afiliados
  massiveUpload: (idGroup, idEmpresa, excelFile) => {
    const formData = new FormData();
    formData.append('file', excelFile);
    const url = `${config.baseUrl}${config.port}${config.context}/user/import/affiliates/${idGroup}`;
    return axios.post(
      url,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'idEmpresa': idEmpresa
        }
      }
    );
  },

  // Descargar plantilla de eliminación
  downloadDeleteTemplate: (idEmpresa) => {
    const url = `${config.baseUrl}${config.port}${config.context}/user/import/affiliates/delete-template`;
    return axios.get(
      url,
      {
        headers: {
          'idEmpresa': idEmpresa
        },
        responseType: 'blob'
      }
    );
  },

  // Consultar estado del job
  checkJobStatus: (jobId, idEmpresa) => {
    const url = `${config.baseUrl}${config.port}${config.context}/user/import/affiliates/job/${jobId}`;
    return axios.get(url, {
      headers: {
        'idEmpresa': idEmpresa
      }
    });
  },

  // Eliminar afiliados masivamente
  massiveDelete: (idGroup, idEmpresa, excelFile) => {
    const formData = new FormData();
    formData.append('file', excelFile);
    const url = `${config.baseUrl}${config.port}${config.context}/user/import/affiliates/bulk-delete/${idGroup}`;
    return axios.post(
      url,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'idEmpresa': idEmpresa
        }
      }
    );
  }
};
